// Renders a license's machine binding: the mono machine id, or a muted
// "Belum terikat" when unbound. Shared across the three admin views that show a
// license row (Licenses, UserDetail, OrderDetail) so the wording and truncation
// stay identical everywhere.

export function MachineBinding({ machineId }: { machineId: string | null }) {
  if (!machineId) return <span className="text-fg-2">Belum terikat</span>;
  return <span className="font-mono text-xs break-all">{machineId}</span>;
}
